<template>
  <div
    v-if="organization"
    class="content-block content-block--separated contact-block"
  >
    <h3 class="text-center">
      Have a question? Please ask us.
    </h3>
    <v-layout
      justify-space-between
      wrap
    >
      <v-col
        xs12
        sm6
        order-1
        order-sm-0
      >
        <v-card class="contact-block__form">
          <v-form
            ref="form"
            @submit.prevent
          >
            <v-text-field
              v-model="contactForm.name"
              label="Enter your name"
              :rules="[rules.required]"
              variant="outlined"
              append-icon="person"
            />
            <v-text-field
              v-model="contactForm.email"
              label="Enter your email"
              :rules="[rules.required, rules.isEmail]"
              variant="outlined"
              append-icon="email"
            />
            <phone-input
              ref="phoneInput"
              outlined
              :rules="[rules.required]"
            />
            <v-textarea
              v-model="contactForm.message"
              label="Enter your message"
              :rules="[rules.required]"
              variant="outlined"
              append-icon="message"
            />
            <v-btn
              color="primary"
              size="large"
              @click.native="sendForm"
            >
              {{ propertyId ? 'Contact Property' : 'Contact Company' }}
            </v-btn>
          </v-form>

          <div
            class="contact-block__sent"
            v-if="formSent"
          >
            <template v-if="formError">
              <v-icon color="error">
                clear
              </v-icon>
              <h2 class="mb-5">
                Message failed
              </h2>
            </template>
            <template v-else>
              <v-icon color="primary">
                check
              </v-icon>
              <h2 class="mb-5">
                Message sent
              </h2>
            </template>
            <v-btn
              variant="text"
              color="primary"
              @click.native="clearForm"
            >
              Send again
            </v-btn>
          </div>
        </v-card>
      </v-col>

      <v-col
        v-if="contactData"
        xs12
        sm5
        md4
        order-0
        order-sm-1
      >
        <div class="contact-block__info text-center text-sm-left">
          <div class="content-line">
            <div class="content-line__title">
              General
            </div>
            <div class="content-line__text">
              {{ contactData.street }},<br>
              {{ contactData.city }}, {{ contactData.state }} {{ contactData.code }}
            </div>
          </div>

          <div class="content-line">
            <div class="content-line__title">
              Management
            </div>
            <div class="content-line__text">
              {{ contactData.manager_fname }} {{ contactData.manager_lname }}<br>
              <a :href="'tel:' + contactData.phone_number">{{ contactData.phone_number }}</a><br>
              <a
                class="btnNoBorder"
                :href="`mailto:${ contactData.manager_email }`"
                target="_top"
              >{{ contactData.manager_email }}</a>
            </div>
          </div>

          <div
            v-if="contactData.office_hours"
            class="content-line"
          >
            <div class="content-line__title">
              Office Hours
            </div>
            <div class="content-line__text">
              {{ contactData.office_hours }}
            </div>
          </div>
        </div>
      </v-col>
    </v-layout>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator'
import validationRules from '../../validation/validationRules'
import PhoneInput from '../common/PhoneInput.vue'

const namespace: string = 'organization'

@Component({ components: { PhoneInput } })

export default class ContactForm extends Vue {
  @Prop({ type: [String, Number] }) propertyId!: string
  @Prop({ type: [Object] }) contactData!: any

  get organization () {
    return this.$store.getters[`${namespace}/organization`]
  }

  formSent = false
  formError = false
  contactForm = {
    phone_number: '',
    message: '',
    name: '',
    email: '',
  }

  rules = {
    required: v => validationRules.checkRequired(v) || 'Required',
    isEmail: v => validationRules.checkEmail(v) || 'Invalid Email',
    isPhone: v => validationRules.checkPhone(v) || 'Invalid Phone',
  }

  get isValid (): boolean {
    return (this.$refs.form as typeof Vue & { validate: () => boolean }).validate()
  }

  clearForm () {
    this.formSent = false
    this.formError = false
    for (const key in this.contactForm) {
      this.contactForm[key] = ''
    }
  }

  async sendForm () {
    if (!this.isValid) return
    // @ts-ignore
    this.contactForm.phone_number = this.$refs.phoneInput ? this.$refs.phoneInput?.getFullValue() : this.formData.cell_phone
    try {
      if (this.propertyId) {
        await this.$api.property.sendContactForm(this.propertyId, this.contactForm)
      } else {
        await this.$api.organization.sendContactForm(this.organization.id, this.contactForm)
      }
    } catch (e) {
      console.warn(e)
      this.formError = true
    } finally {
      this.formSent = true
    }
  }
}
</script>

<style lang="scss">
  .contact-block {
    padding-bottom: 5.625rem;
    h3 {
      margin-bottom: 6.375rem;
    }

    &__form.v-card {
      padding: 1.75rem;
      box-shadow: 0px 1px 3px rgba(153, 155, 168, 0.3);
      position: relative;
    }

    &__info {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    &__sent {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      z-index: 100;
      background-color: white;

      .v-icon {
        font-size: 5rem;
      }
    }
  }
</style>
